import GamerHeader from '@components/ui/gamer-header/gamer-header';
export default GamerHeader;
